import React, { useState } from 'react';
import axios from 'axios';
import { Lock } from 'lucide-react';
import SiteLogo from '../components/Layout/SiteLogo';
import { useAuth } from '../contexts/AuthContext';

const BillingBlocked: React.FC = () => {
  const { isSuperAdmin, logout } = useAuth();
  const [loadingPortal, setLoadingPortal] = useState(false);
  const [portalError, setPortalError] = useState('');

  const openPortal = async () => {
    setLoadingPortal(true);
    setPortalError('');
    try {
      const response = await axios.get('/billing/portal-link');
      window.location.href = response.data.url;
    } catch (error) {
      setPortalError('Não foi possível abrir o portal de pagamento. Entre em contato com o suporte.');
    } finally {
      setLoadingPortal(false);
    }
  };

  return (
    <div className="min-h-[100dvh] bg-slate-100 flex items-center justify-center p-4 sm:p-6">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-6 sm:p-8">
        <div className="flex justify-center mb-4">
          <SiteLogo size="md" className="justify-center" />
        </div>
        <Lock className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h1 className="text-xl font-bold text-gray-900 mb-2">Acesso suspenso</h1>
        <p className="text-gray-600 leading-relaxed mb-6">
          O acesso à área administrativa está suspenso por pendência de pagamento da licença. Regularize o
          pagamento para restabelecer o acesso.
        </p>

        {isSuperAdmin && (
          <button
            onClick={openPortal}
            disabled={loadingPortal}
            className="w-full bg-primary text-white font-semibold py-2.5 rounded-lg disabled:opacity-60"
          >
            {loadingPortal ? 'Abrindo...' : 'Gerenciar pagamento'}
          </button>
        )}
        {portalError && <p className="text-red-600 text-sm mt-3">{portalError}</p>}

        <button onClick={logout} className="w-full mt-3 text-gray-500 text-sm underline">
          Sair
        </button>
      </div>
    </div>
  );
};

export default BillingBlocked;
